import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Clock, MapPin, Users } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { listEvents, mediaUrl } from "../lib/api";

const fmtDate = (d) =>
  new Date(d + "T00:00:00").toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

export default function Events() {
  const [EVENTS, setEvents] = useState([]);
  useReveal([EVENTS]);
  useEffect(() => {
    listEvents().then(setEvents).catch(() => setEvents([]));
  }, []);
  return (
    <div>
      <section className="relative pt-40 pb-20 bg-[#0b1f33] overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: "url(/media/brand-poster.jpg)" }} />
        <div className="relative max-w-6xl mx-auto px-6 text-center">
          <p className="text-[#2f74c9] tracking-[0.3em] text-xs uppercase mb-4">Événements</p>
          <h1 className="font-serif-display text-4xl md:text-6xl text-white">Séminaires &amp; visites VIP</h1>
          <p className="text-white/70 mt-5 max-w-2xl mx-auto">
            Rejoignez nos événements exclusifs, en ligne ou en présentiel, pour découvrir les meilleures opportunités au Mexique.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 space-y-8">
          {EVENTS.map((e, i) => (
            <div
              key={e.id}
              className={`reveal reveal-delay-${i % 3} group grid grid-cols-1 md:grid-cols-5 gap-0 bg-white rounded-lg overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl transition-shadow`}
            >
              <div className="md:col-span-2 h-56 md:h-auto overflow-hidden">
                <img src={mediaUrl(e.image)} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="md:col-span-3 p-8 flex flex-col justify-center">
                <span className={`w-fit text-xs font-600 px-3 py-1 rounded-full mb-3 ${e.type === "En ligne" ? "bg-sky-100 text-sky-800" : "bg-[#2f74c9]/20 text-[#8a6d24]"}`}>
                  {e.type}
                </span>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#0b1f33]">{e.title}</h3>
                <p className="text-slate-500 mt-2 leading-relaxed">{e.description}</p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 text-sm text-slate-600">
                  <span className="flex items-center gap-1.5"><Calendar size={15} className="text-[#2f74c9]" /> {fmtDate(e.date)}</span>
                  <span className="flex items-center gap-1.5"><Clock size={15} className="text-[#2f74c9]" /> {e.time}</span>
                  <span className="flex items-center gap-1.5"><MapPin size={15} className="text-[#2f74c9]" /> {e.location}</span>
                  <span className="flex items-center gap-1.5"><Users size={15} className="text-[#2f74c9]" /> {e.seats} places</span>
                </div>
                {e.cta_link ? (
                  <a href={e.cta_link} target="_blank" rel="noreferrer" className="btn-gold w-fit mt-6 px-6 py-3 rounded-sm font-600 text-sm">
                    {e.cta_label || "Réserver ma place"}
                  </a>
                ) : (
                  <Link to="/contact" className="btn-gold w-fit mt-6 px-6 py-3 rounded-sm font-600 text-sm">
                    {e.cta_label || "Réserver ma place"}
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
